(() => {
  if (customElements.get('simple-tabs')) {
    return;
  }

  class SimpleTabs extends HTMLElement {
    constructor() {
      super();
      this.triggers = this.querySelectorAll('[data-target]');
      this.activeClas = this.dataset.class
    }

    connectedCallback() {
      if (window.location.hash.includes('tab-')) {
        const currentTab = document.querySelector(`[data-target="${window.location.hash}"]`);
        this.toggleTabs(currentTab, window.location.hash);
      };

      this.triggers.forEach(trigger => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();

          this.toggleTabs(trigger, trigger.dataset.target);
        });
      });
    }

    toggleTabs(tabTrigger, dataTarget) {
      const targetTab = document.querySelector(dataTarget);

      this.triggers.forEach(itemTrigger => {
        const siblingDataTarget = itemTrigger.dataset.target;
        const siblingTargetTab = document.querySelector(siblingDataTarget);

        itemTrigger.classList.remove(this.activeClas);
        siblingTargetTab.classList.remove(this.activeClas);
      });

      tabTrigger.classList.add(this.activeClas);

      if (targetTab != null) {
        targetTab.classList.add(this.activeClas);
      };
    }
  }

  customElements.define('simple-tabs', SimpleTabs);
})();
